// An on/off switch (role="switch") with its label and a line saying what
// it means. The share sheets' link and visibility switches (slice 8).
import type { ReactNode } from "react";
import { COLORS, RADIUS, SPACE } from "../lib/constants";
import { supporting } from "./recipeStyles";

// An on/off switch with its label and a line saying what it means.
export function Toggle({ on, label, disabled, onChange, children }: { on: boolean; label: string; disabled?: boolean; onChange: (on: boolean) => void; children: ReactNode }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: SPACE.xl }}>
      <span style={{ minWidth: 0 }}>
        <strong>{label}</strong>
        <span style={{ ...supporting, display: "block" }}>{children}</span>
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={on}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange(!on)}
        style={{ width: 52, height: 32, flexShrink: 0, borderRadius: RADIUS.pill, border: `1px solid ${on ? COLORS.accent : COLORS.line}`, background: on ? COLORS.accent : COLORS.card, position: "relative", cursor: "pointer", opacity: disabled ? 0.6 : 1, padding: 0 }}
      >
        <span aria-hidden="true" style={{ position: "absolute", top: 3, left: on ? 23 : 3, width: 24, height: 24, borderRadius: RADIUS.pill, background: on ? COLORS.onAccent : COLORS.soft, transition: "left 0.15s ease" }} />
      </button>
    </div>
  );
}
